import React from 'react';
import ForeverFeline from "/public/ForeverFeline.pdf"; 
import styles from "./OfferInfoNotification.scss";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";

const OfferInfoNotification = ({ userProfile }) => {
  const history = useHistory();

  const navigateToEnrollment = () => {
    if (window.location.pathname.includes('admin')) {
      history.push(`/admin/provider/1/location/${userProfile.nodeId}/offer-enrollment`);
    } else {
      history.push(`/provider/location/${userProfile.nodeId}/offer-enrollment`);
    }
  };

  return (
    <div className={styles.container}>
      <p>
        This pilot program is a partnership between Boehringer Ingelheim and IDEXX to offer a
        cat owner a rebate of $25 when they test and vaccinate their cat for FeLV.
        For more information, please refer to the {" "}
        <a
          href={ForeverFeline}
          target="_blank"
          rel="noopener noreferrer"
        >
          detailer and terms and conditions.
        </a>
      </p>
      <div className={styles.buttonContainer}>
        <button
          onClick={navigateToEnrollment}
          className={styles.viewButton}
        >
          Go to Enrollment Page
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userProfile: state.user.userProfile
});

export default connect(mapStateToProps)(OfferInfoNotification);